/** 把 stickers 清单铺成界面上的卡片。地址是前缀加文件名。 */

const STICKER_TYPE_LABEL = {
  solo: { still: 'static solo', animated: 'animated solo' },
  pack: { still: 'static pack', animated: 'animated pack' },
}

/** 页面把 isAnimated 和 stickerType 拼成一句英文。存库只有 solo / pack。 */
export function stickerTypeLabel(exta) {
  if (!exta) {
    return '—'
  }
  const pair = STICKER_TYPE_LABEL[exta.stickerType]
  if (!pair) {
    return '—'
  }
  return exta.isAnimated ? pair.animated : pair.still
}

function stickerEntries(exta) {
  if (!Array.isArray(exta.stickers)) {
    return []
  }
  return exta.stickers.map((item, index) => ({
    stickerIndex: index,
    file: item && item.file,
    id: (item && item.id) || '',
    emojis: item && Array.isArray(item.emojis) ? item.emojis : [],
    qualified: !!item && item.qualified === true,
    reason: (item && item.reason) || '',
  }))
}

export function stickerCards(exta) {
  if (!exta || !exta.resourceUrlPrefix) {
    return []
  }
  const prefix = exta.resourceUrlPrefix
  const trayId = exta.trayStickerId || ''
  return stickerEntries(exta).filter((item) => item.file).map((item) => ({
    url: prefix + item.file,
    fileName: item.file,
    id: item.id || '',
    stickerIndex: item.stickerIndex,
    emojis: item.emojis,
    qualified: item.qualified,
    reason: item.reason,
    tray: !!trayId && item.id === trayId,
  }))
}

/** 多数聊天 App 的贴纸边长在 512 左右，源图更小时导出要放大，只提示、不影响合格与下发。 */
export const STICKER_MIN_EDGE = 512

/** 按浏览器读到的真实宽高给提示；还没读到宽高时不提示。 */
export function stickerSizeWarning(width, height) {
  const edge = Math.max(Number(width) || 0, Number(height) || 0)
  if (!edge || edge >= STICKER_MIN_EDGE) {
    return ''
  }
  return `尺寸偏小（最长边 ${edge} 像素），导出到其他 App 可能模糊`
}

/** 列表封面用被选中的那张贴纸，合格与否都行。没有 trayStickerId 时返回空，页面保持「待选择」。 */
export function coverUrl(exta) {
  if (!exta || !exta.resourceUrlPrefix || !exta.trayStickerId) {
    return ''
  }
  const card = stickerCards(exta).find((item) => item.tray)
  return card && card.id ? card.url : ''
}
